// Product mobile slider
const productSlider = document.querySelector('.product-slider');
let productSliderInstance = {};
const settingsSlider = {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  pagination: {
    el: '.product-slider-pagination',
    clickable: true
  }
}

if (productSlider){
  window.addEventListener('load', pdpSwiperOnLoadOrResize);
  window.addEventListener('resize', pdpSwiperOnLoadOrResize);
}

function pdpSwiperOnLoadOrResize() {
  if (window.innerWidth > 767) {
    if (productSlider.classList.contains('swiper-initialized')) {
      productSliderInstance.destroy({
        deleteInstance: true,
        cleanStyles: true
      });
    }
  } else {
    if (!productSlider.classList.contains('swiper-initialized')) {
      productSliderInstance = new Swiper('.product-slider', settingsSlider);
      window.productSlider = productSliderInstance
    }
  }
}

customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        console.log(parsedState)

        getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        this.cartDrawer.open();
      });
  }
});